export const ISO_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]'
export const ISO_DATE_WITH_TZ_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ'
